module.exports = __webpack_public_path__ + "static/media/quadrant-dweb-curious-civilians.eeb0d554.svg";